import Vue from 'vue';
import { createDecorator } from 'vue-class-component';

// Can be added to any method of any Vue-component class
// Example:
// @Component
// class HumanFinger extends Vue {
//   @StopActivatingPopup()
//   private wiggle(): void {
//     // ...
//   }
// }

// This would have been nicer as a click event but it is't possible, as there are
// no feature to add custom modifies to existing events
// https://github.com/vuejs/vue/issues/2235

export function StopActivatingPopup() {
  return function(target: Vue, key: string) {
    return createDecorator((componentOptions, methodName) => {
      if (!componentOptions) return;
      if (!componentOptions.methods) return;
      if (!componentOptions.methods[methodName]) return;

      const originalMethod = componentOptions.methods[methodName];
      const newMethodName = `__stop_popup_active_${methodName}`;

      componentOptions.methods[newMethodName] = originalMethod;
      componentOptions.methods[methodName] = function(this: Vue, event, ...args: any[]) { // eslint-disable-line @typescript-eslint/no-explicit-any
        // prevent the modal to get a click event, if it does, the main form will be active.
        event.stopPropagation();

        return (this as any)[newMethodName](event, ...args); // eslint-disable-line @typescript-eslint/no-explicit-any
      };
    })(target, key);
  };
}
